const wowApp = require('angular').module('wowApp.shop');

wowApp.component('receiptRewardsPrice', require('./receipt-rewards-price'));
wowApp.component('receiptRewardsProducts', require('./receipt-rewards-products'));
wowApp.component('receiptRewards', require('./receipt-rewards'));



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/receipt-rewards/index.js
 **/